import { render, staticRenderFns } from "./BaseFormSelect.vue?vue&type=template&id=60a5fa27&scoped=true"
import script from "./BaseFormSelect.vue?vue&type=script&lang=js"
export * from "./BaseFormSelect.vue?vue&type=script&lang=js"
import style0 from "./BaseFormSelect.vue?vue&type=style&index=0&id=60a5fa27&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a5fa27",
  null
  
)

export default component.exports